var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "p",
      { staticClass: "mb-3 text-center" },
      [
        _vm._t("labelText", function () {
          return [_vm._v(_vm._s(_vm._f("trans")("Credits")) + ":")]
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("strong", { staticClass: "font-size-125" }, [
          _vm._v(_vm._s(_vm.selectedCreditsReadable)),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "px-5 pb-4" },
      [
        _c("VueSlider", {
          attrs: {
            adsorb: true,
            marks: _vm.getMark,
            tooltip: "none",
            clickable: true,
            "drag-on-click": true,
            disabled: _vm.disabled,
            data: Object.keys(_vm.selectableCredits),
            process: _vm.getProcess,
            duration: 0,
          },
          model: {
            value: _vm.selectedCredits,
            callback: function ($$v) {
              _vm.selectedCredits = $$v
            },
            expression: "selectedCredits",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }